const CUSTOM_FETCH_ERROR_NAME = 'CustomFetchApiError';
export const REDIRECT_ERROR = 'A Redirect Occurred';

export default class CustomFetchApiError extends Error {
    public name = CUSTOM_FETCH_ERROR_NAME;

    public url: string;

    public body?: object;

    public constructor(message?: string, public code?: number, public isRedirect?: boolean) {
        super(message);
        this.code = code;
        this.isRedirect = isRedirect;
    }

    public static isCustomError(error: Error): error is CustomFetchApiError {
        return error.name === CUSTOM_FETCH_ERROR_NAME;
    }
}

export const getErrorCustomData = (error: Error) => {
    if (CustomFetchApiError.isCustomError(error)) {
        const { code, url, body } = error;
        return { code, url, body };
    }

    return {};
};
